module.exports = __webpack_public_path__ + "static/media/done.ce59afd4.svg";